export default "__VITE_ASSET__CWQRPf_v__"